globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.AddMediaImages = (function(superClass) {

  utils.extend(AddMediaImages, superClass);

  function AddMediaImages() {
    this.ajaxResourcePath = "/configuration/mediatheque/images";

    return AddMediaImages.__super__.constructor.apply(this, arguments);
  }

  $.extend(AddMediaImages.prototype, {
    init: function() {
      return AddMediaImages.__super__.init.apply(this, arguments);
    }
  });

  return AddMediaImages;

})(appCustomerSpace.Modals.Settings.AddMediaAbstractFiles);
